module.exports = __webpack_public_path__ + "static/3-170b4631221530926cc5ee50d572ccf9.jpg";